/**
 * 服务地区配置
 * Shared APAC coverage data for homepage and related sections.
 */

const localized = (zh, en, ja = en, ko = en) => ({
  zh,
  en,
  ja,
  ko
});

const localizedList = (zh, en, ja = en, ko = en) => ({
  zh,
  en,
  ja,
  ko
});

const defaultEmail = 'info@global-data.com';
const comingSoonText = localized('敬请期待', 'Coming Soon', '近日公開', '곧 제공 예정');
const comingSoonAddress = localizedList(['敬请期待'], ['Coming Soon'], ['近日公開'], ['곧 제공 예정']);

const createOffice = ({
  id,
  title,
  city,
  coordinates,
  addressLines = comingSoonAddress,
  email = defaultEmail,
  businessHours,
  isComingSoon = false
}) => ({
  id,
  title,
  city,
  coordinates,
  addressLines,
  email,
  businessHours,
  isComingSoon
});

export const serviceRegions = [
  {
    code: 'CN',
    name: localized('中国大陆', 'China', '中国本土', '중국 본토'),
    city: localized('上海 / 北京 / 深圳', 'Shanghai / Beijing / Shenzhen', '上海 / 北京 / 深圳', '상하이 / 베이징 / 선전'),
    coordinates: { lat: 31.2411, lng: 121.4754 },
    office: localized(
      '上海、北京、深圳本地交付团队',
      'Local delivery teams in Shanghai, Beijing, and Shenzhen',
      '上海・北京・深圳のローカルデリバリー体制',
      '상하이, 베이징, 선전 현지 딜리버리 팀'
    ),
    description: localized(
      '覆盖中国大陆核心城市，支持本地实施、现场服务与跨区域交付协同。',
      'Covers major cities in Mainland China with local implementation, onsite support, and regional delivery coordination.',
      '中国本土の主要都市をカバーし、現地導入、オンサイト支援、広域連携に対応します。',
      '중국 본토 핵심 도시를 커버하며 현지 구축, 온사이트 지원, 광역 협업 딜리버리를 제공합니다.'
    ),
    email: defaultEmail,
    businessHours: localized('周一至周五 9:00-18:00', 'Monday-Friday 9:00-18:00', '月曜日～金曜日 9:00-18:00', '월요일-금요일 9:00-18:00'),
    timezone: 'Asia/Shanghai',
    offices: [
      createOffice({
        id: 'china-shanghai',
        title: localized('上海服务中心', 'Shanghai Service Center', '上海サービスセンター', '상하이 서비스센터'),
        city: localized('上海', 'Shanghai', '上海', '상하이'),
        coordinates: { lat: 31.2411, lng: 121.4754 },
        addressLines: localizedList(
          [
            '上海市静安区西藏北路199号',
            '光明地产大厦1003-1室'
          ],
          [
            'Room 1003-1, Guangming Real Estate Building',
            'No. 199 Xizang North Road, Jing’an District, Shanghai, China'
          ],
          [
            '上海市静安区西蔵北路199号',
            '光明地産大厦1003-1室'
          ],
          [
            'Room 1003-1, Guangming Real Estate Building',
            'No. 199 Xizang North Road, Jing’an District, Shanghai, China'
          ]
        ),
        businessHours: localized('周一至周五 9:00-18:00', 'Monday-Friday 9:00-18:00', '月曜日～金曜日 9:00-18:00', '월요일-금요일 9:00-18:00')
      }),
      createOffice({
        id: 'china-beijing',
        title: localized('北京服务中心', 'Beijing Service Center', '北京サービスセンター', '베이징 서비스센터'),
        city: localized('北京', 'Beijing', '北京', '베이징'),
        coordinates: { lat: 39.9042, lng: 116.4074 },
        addressLines: localizedList(
          [
            '北京市怀柔区雁栖镇京加路18号'
          ],
          [
            'No. 18, Jingjia Road, Yanqi Town, Huairou District, Beijing, China'
          ],
          [
            '北京市懐柔区雁栖鎮京加路18号'
          ],
          [
            'No. 18, Jingjia Road, Yanqi Town, Huairou District, Beijing, China'
          ]
        ),
        businessHours: localized('周一至周五 9:00-18:00', 'Monday-Friday 9:00-18:00', '月曜日～金曜日 9:00-18:00', '월요일-금요일 9:00-18:00')
      }),
      createOffice({
        id: 'china-shenzhen',
        title: localized('深圳服务中心', 'Shenzhen Service Center', '深圳サービスセンター', '선전 서비스센터'),
        city: localized('深圳', 'Shenzhen', '深圳', '선전'),
        coordinates: { lat: 22.5412, lng: 114.0539 },
        addressLines: localizedList(
          [
            '深圳市福田区天安创新科技广场',
            '一期B座1407-55'
          ],
          [
            'Unit 55, Room 1407, Building B, Phase 1',
            'Tian’an Innovation Technology Plaza, Futian District, Shenzhen, China'
          ],
          [
            '深圳市福田区天安創新科技広場',
            '一期B座1407-55'
          ],
          [
            'Unit 55, Room 1407, Building B, Phase 1',
            'Tian’an Innovation Technology Plaza, Futian District, Shenzhen, China'
          ]
        ),
        businessHours: localized('周一至周五 9:00-18:00', 'Monday-Friday 9:00-18:00', '月曜日～金曜日 9:00-18:00', '월요일-금요일 9:00-18:00')
      })
    ]
  },
  {
    code: 'HK',
    name: localized('中国香港', 'Hong Kong', '香港', '홍콩'),
    city: localized('香港', 'Hong Kong', '香港', '홍콩'),
    coordinates: { lat: 22.3070, lng: 114.1714 },
    office: localized(
      '香港本地服务与跨境协同支持',
      'Local support and cross-border coordination in Hong Kong',
      '香港現地支援と越境連携',
      '홍콩 현지 및 크로스보더 지원'
    ),
    description: localized(
      '支持香港本地业务与跨境项目交付，可联动区域团队快速响应。',
      'Supports Hong Kong local operations and cross-border projects with regional response capabilities.',
      '香港ローカル案件と越境案件の両方に対応し、地域連携で迅速に支援します。',
      '홍콩 현지 업무와 국경 간 프로젝트를 지원하며 지역 팀과 연계해 빠르게 대응합니다.'
    ),
    email: defaultEmail,
    businessHours: localized('周一至周五 9:00-18:00', 'Monday-Friday 9:00-18:00', '月曜日～金曜日 9:00-18:00', '월요일-금요일 9:00-18:00'),
    timezone: 'Asia/Hong_Kong',
    offices: [
      createOffice({
        id: 'hongkong',
        title: localized('香港服务中心', 'Hong Kong Service Center', '香港サービスセンター', '홍콩 서비스센터'),
        city: localized('香港', 'Hong Kong', '香港', '홍콩'),
        coordinates: { lat: 22.3070, lng: 114.1714 },
        addressLines: localizedList(
          [
            '香港九龙油麻地鸦打街33号',
            '雅达商业大厦1楼A室'
          ],
          [
            'Room A, 1/F., Arthur Commercial Building',
            '33 Arthur Road, Yau Ma Tei, Kowloon, Hong Kong'
          ],
          [
            '香港九龍油麻地鴉打街33号',
            '雅達商業大廈1階A室'
          ],
          [
            'Room A, 1/F., Arthur Commercial Building',
            '33 Arthur Road, Yau Ma Tei, Kowloon, Hong Kong'
          ]
        ),
        businessHours: localized('周一至周五 9:00-18:00', 'Monday-Friday 9:00-18:00', '月曜日～金曜日 9:00-18:00', '월요일-금요일 9:00-18:00')
      })
    ]
  },
  {
    code: 'MO',
    name: localized('中国澳门', 'Macau', 'マカオ', '마카오'),
    city: localized('澳门', 'Macau', 'マカオ', '마카오'),
    coordinates: { lat: 22.1987, lng: 113.5439 },
    office: localized('澳门服务节点筹备中', 'Macau service point is coming soon', 'マカオサービス拠点準備中', '마카오 서비스 포인트 준비 중'),
    description: localized(
      '澳门服务节点建设中，现阶段可由区域团队协同支持。',
      'Macau service coverage is being expanded and is currently coordinated by nearby regional teams.',
      'マカオのサービス拠点は準備中で、現段階では周辺地域チームと連携して対応します。',
      '마카오 서비스 거점은 준비 중이며 현재는 인접 지역 팀과 연계해 지원합니다.'
    ),
    email: defaultEmail,
    businessHours: localized('周一至周五 9:00-18:00', 'Monday-Friday 9:00-18:00', '月曜日～金曜日 9:00-18:00', '월요일-금요일 9:00-18:00'),
    timezone: 'Asia/Macau',
    offices: [
      createOffice({
        id: 'macau',
        title: localized('澳门服务区域', 'Macau Service Coverage', 'マカオサービスエリア', '마카오 서비스 권역'),
        city: localized('澳门', 'Macau', 'マカオ', '마카오'),
        coordinates: { lat: 22.1987, lng: 113.5439 },
        addressLines: comingSoonAddress,
        businessHours: localized('周一至周五 9:00-18:00', 'Monday-Friday 9:00-18:00', '月曜日～金曜日 9:00-18:00', '월요일-금요일 9:00-18:00'),
        isComingSoon: true
      })
    ]
  },
  {
    code: 'TW',
    name: localized('中国台湾', 'Taiwan', '台湾', '대만'),
    city: localized('台北', 'Taipei', '台北', '타이베이'),
    coordinates: { lat: 25.0330, lng: 121.5654 },
    office: comingSoonText,
    description: localized(
      '台湾地区服务节点规划中，当前由区域团队提供协同支持。',
      'Taiwan service coverage is being planned, with current support coordinated through regional teams.',
      '台湾向けサービス拠点は計画中で、現在は地域チームが連携して支援します。',
      '대만 서비스 거점은 계획 중이며 현재는 지역 팀이 연계해 지원합니다.'
    ),
    email: defaultEmail,
    businessHours: localized('周一至周五 9:00-18:00', 'Monday-Friday 9:00-18:00', '月曜日～金曜日 9:00-18:00', '월요일-금요일 9:00-18:00'),
    timezone: 'Asia/Taipei',
    offices: [
      createOffice({
        id: 'taiwan',
        title: localized('台北服务区域', 'Taipei Service Coverage', '台北サービスエリア', '타이베이 서비스 권역'),
        city: localized('台北', 'Taipei', '台北', '타이베이'),
        coordinates: { lat: 25.0330, lng: 121.5654 },
        addressLines: comingSoonAddress,
        businessHours: localized('周一至周五 9:00-18:00', 'Monday-Friday 9:00-18:00', '月曜日～金曜日 9:00-18:00', '월요일-금요일 9:00-18:00'),
        isComingSoon: true
      })
    ]
  },
  {
    code: 'JP',
    name: localized('日本', 'Japan', '日本', '일본'),
    city: localized('东京', 'Tokyo', '東京', '도쿄'),
    coordinates: { lat: 35.7412, lng: 139.7600 },
    office: localized('东京本地服务与交付支持', 'Local service and delivery support in Tokyo', '東京ローカルサービス対応', '도쿄 현지 서비스 및 딜리버리 지원'),
    description: localized(
      '覆盖东京及周边重点区域，支持日语环境下的本地交付与项目协同。',
      'Supports Tokyo and surrounding business districts with local delivery in Japanese-speaking environments.',
      '東京および周辺主要エリアで、日本語環境に対応したローカルデリバリーを提供します。',
      '도쿄 및 주변 주요 지역에서 일본어 환경의 현지 딜리버리를 지원합니다.'
    ),
    email: defaultEmail,
    businessHours: localized('周一至周五 9:00-18:00 JST', 'Monday-Friday 9:00-18:00 JST', '月曜日～金曜日 9:00-18:00 JST', '월요일-금요일 9:00-18:00 JST'),
    timezone: 'Asia/Tokyo',
    offices: [
      createOffice({
        id: 'japan',
        title: localized('东京服务中心', 'Tokyo Service Center', '東京サービスセンター', '도쿄 서비스센터'),
        city: localized('东京', 'Tokyo', '東京', '도쿄'),
        coordinates: { lat: 35.7412, lng: 139.7600 },
        addressLines: localizedList(
          [
            '208, 2-9-17 HIGASHITABATA, KITA-KU',
            'TOKYO 114-0013, JAPAN',
            '東京都北区東田端二丁目9番17-208号'
          ],
          [
            '208, 2-9-17 HIGASHITABATA, KITA-KU',
            'TOKYO 114-0013, JAPAN'
          ],
          [
            '208, 2-9-17 HIGASHITABATA, KITA-KU',
            'TOKYO 114-0013, JAPAN',
            '東京都北区東田端二丁目9番17-208号'
          ],
          [
            '208, 2-9-17 HIGASHITABATA, KITA-KU',
            'TOKYO 114-0013, JAPAN'
          ]
        ),
        businessHours: localized('周一至周五 9:00-18:00 JST', 'Monday-Friday 9:00-18:00 JST', '月曜日～金曜日 9:00-18:00 JST', '월요일-금요일 9:00-18:00 JST')
      })
    ]
  },
  {
    code: 'KR',
    name: localized('韩国', 'South Korea', '韓国', '대한민국'),
    city: localized('首尔', 'Seoul', 'ソウル', '서울'),
    coordinates: { lat: 37.5665, lng: 126.9780 },
    office: comingSoonText,
    description: localized(
      '韩国服务节点规划中，当前可通过区域团队支持跨境项目交付。',
      'South Korea coverage is being planned and currently supported through regional delivery coordination.',
      '韓国向けサービス拠点は計画中で、現在は地域チームが連携して越境案件を支援します。',
      '한국 서비스 거점은 계획 중이며 현재는 지역 팀이 연계해 크로스보더 프로젝트를 지원합니다.'
    ),
    email: defaultEmail,
    businessHours: localized('周一至周五 9:00-18:00 KST', 'Monday-Friday 9:00-18:00 KST', '月曜日～金曜日 9:00-18:00 KST', '월요일-금요일 9:00-18:00 KST'),
    timezone: 'Asia/Seoul',
    offices: [
      createOffice({
        id: 'korea',
        title: localized('首尔服务区域', 'Seoul Service Coverage', 'ソウルサービスエリア', '서울 서비스 권역'),
        city: localized('首尔', 'Seoul', 'ソウル', '서울'),
        coordinates: { lat: 37.5665, lng: 126.9780 },
        addressLines: comingSoonAddress,
        businessHours: localized('周一至周五 9:00-18:00 KST', 'Monday-Friday 9:00-18:00 KST', '月曜日～金曜日 9:00-18:00 KST', '월요일-금요일 9:00-18:00 KST'),
        isComingSoon: true
      })
    ]
  },
  {
    code: 'AU',
    name: localized('澳大利亚', 'Australia', 'オーストラリア', '호주'),
    city: localized('墨尔本', 'Melbourne', 'メルボルン', '멜버른'),
    coordinates: { lat: -37.8136, lng: 144.9631 },
    office: comingSoonText,
    description: localized(
      '澳大利亚服务节点筹备中，当前由亚太区域团队协同支持。',
      'Australia service coverage is in preparation and currently supported by APAC regional teams.',
      'オーストラリア向けサービス拠点は準備中で、現在はAPAC地域チームが連携して支援します。',
      '호주 서비스 거점은 준비 중이며 현재는 APAC 지역 팀이 연계해 지원합니다.'
    ),
    email: defaultEmail,
    businessHours: localized('周一至周五 9:00-18:00 AEST', 'Monday-Friday 9:00-18:00 AEST', '月曜日～金曜日 9:00-18:00 AEST', '월요일-금요일 9:00-18:00 AEST'),
    timezone: 'Australia/Melbourne',
    offices: [
      createOffice({
        id: 'australia',
        title: localized('墨尔本服务区域', 'Melbourne Service Coverage', 'メルボルンサービスエリア', '멜버른 서비스 권역'),
        city: localized('墨尔本', 'Melbourne', 'メルボルン', '멜버른'),
        coordinates: { lat: -37.8136, lng: 144.9631 },
        addressLines: comingSoonAddress,
        businessHours: localized('周一至周五 9:00-18:00 AEST', 'Monday-Friday 9:00-18:00 AEST', '月曜日～金曜日 9:00-18:00 AEST', '월요일-금요일 9:00-18:00 AEST'),
        isComingSoon: true
      })
    ]
  },
  {
    code: 'SG',
    name: localized('新加坡', 'Singapore', 'シンガポール', '싱가포르'),
    city: localized('新加坡', 'Singapore', 'シンガポール', '싱가포르'),
    coordinates: { lat: 1.2752, lng: 103.8453 },
    office: localized('新加坡区域交付枢纽', 'Regional delivery hub in Singapore', 'シンガポール地域ハブ', '싱가포르 지역 딜리버리 허브'),
    description: localized(
      '以新加坡为东南亚枢纽，支持区域项目统筹、实施与交付协同。',
      'Singapore serves as a Southeast Asia hub for project coordination, implementation, and delivery support.',
      'シンガポールを東南アジアのハブとして、案件統括、導入、連携支援を提供します。',
      '싱가포르를 동남아 허브로 하여 프로젝트 총괄, 구축, 딜리버리 협업을 지원합니다.'
    ),
    email: defaultEmail,
    businessHours: localized('周一至周五 9:00-18:00 SGT', 'Monday-Friday 9:00-18:00 SGT', '月曜日～金曜日 9:00-18:00 SGT', '월요일-금요일 9:00-18:00 SGT'),
    timezone: 'Asia/Singapore',
    offices: [
      createOffice({
        id: 'singapore',
        title: localized('新加坡服务中心', 'Singapore Service Center', 'シンガポールサービスセンター', '싱가포르 서비스센터'),
        city: localized('新加坡', 'Singapore', 'シンガポール', '싱가포르'),
        coordinates: { lat: 1.2752, lng: 103.8453 },
        addressLines: localizedList(
          [
            '10 ANSON ROAD #27-18',
            'INTERNATIONAL PLAZA',
            'SINGAPORE (079903)'
          ],
          [
            '10 ANSON ROAD #27-18',
            'INTERNATIONAL PLAZA',
            'SINGAPORE (079903)'
          ],
          [
            '10 ANSON ROAD #27-18',
            'INTERNATIONAL PLAZA',
            'SINGAPORE (079903)'
          ],
          [
            '10 ANSON ROAD #27-18',
            'INTERNATIONAL PLAZA',
            'SINGAPORE (079903)'
          ]
        ),
        businessHours: localized('周一至周五 9:00-18:00 SGT', 'Monday-Friday 9:00-18:00 SGT', '月曜日～金曜日 9:00-18:00 SGT', '월요일-금요일 9:00-18:00 SGT')
      })
    ]
  },
  {
    code: 'MY',
    name: localized('马来西亚', 'Malaysia', 'マレーシア', '말레이시아'),
    city: localized('吉隆坡', 'Kuala Lumpur', 'クアラルンプール', '쿠알라룸푸르'),
    coordinates: { lat: 3.1390, lng: 101.6869 },
    office: comingSoonText,
    description: localized(
      '马来西亚服务节点规划中，当前由新加坡与区域团队协同支持。',
      'Malaysia coverage is being planned and is currently coordinated through Singapore and regional teams.',
      'マレーシア向けサービス拠点は計画中で、現在はシンガポールおよび地域チームが連携して支援します。',
      '말레이시아 서비스 거점은 계획 중이며 현재는 싱가포르 및 지역 팀이 연계해 지원합니다.'
    ),
    email: defaultEmail,
    businessHours: localized('周一至周五 9:00-18:00 MYT', 'Monday-Friday 9:00-18:00 MYT', '月曜日～金曜日 9:00-18:00 MYT', '월요일-금요일 9:00-18:00 MYT'),
    timezone: 'Asia/Kuala_Lumpur',
    offices: [
      createOffice({
        id: 'malaysia',
        title: localized('吉隆坡服务区域', 'Kuala Lumpur Service Coverage', 'クアラルンプールサービスエリア', '쿠알라룸푸르 서비스 권역'),
        city: localized('吉隆坡', 'Kuala Lumpur', 'クアラルンプール', '쿠알라룸푸르'),
        coordinates: { lat: 3.1390, lng: 101.6869 },
        addressLines: comingSoonAddress,
        businessHours: localized('周一至周五 9:00-18:00 MYT', 'Monday-Friday 9:00-18:00 MYT', '月曜日～金曜日 9:00-18:00 MYT', '월요일-금요일 9:00-18:00 MYT'),
        isComingSoon: true
      })
    ]
  },
  {
    code: 'PH',
    name: localized('菲律宾', 'Philippines', 'フィリピン', '필리핀'),
    city: localized('马尼拉', 'Manila', 'マニラ', '마닐라'),
    coordinates: { lat: 14.5995, lng: 120.9842 },
    office: comingSoonText,
    description: localized(
      '菲律宾服务节点规划中，当前由区域团队协同支持本地项目需求。',
      'Philippines service coverage is being planned and currently supported through regional teams.',
      'フィリピン向けサービス拠点は計画中で、現在は地域チームが連携して支援します。',
      '필리핀 서비스 거점은 계획 중이며 현재는 지역 팀이 연계해 지원합니다.'
    ),
    email: defaultEmail,
    businessHours: localized('周一至周五 9:00-18:00 PHT', 'Monday-Friday 9:00-18:00 PHT', '月曜日～金曜日 9:00-18:00 PHT', '월요일-금요일 9:00-18:00 PHT'),
    timezone: 'Asia/Manila',
    offices: [
      createOffice({
        id: 'philippines',
        title: localized('马尼拉服务区域', 'Manila Service Coverage', 'マニラサービスエリア', '마닐라 서비스 권역'),
        city: localized('马尼拉', 'Manila', 'マニラ', '마닐라'),
        coordinates: { lat: 14.5995, lng: 120.9842 },
        addressLines: comingSoonAddress,
        businessHours: localized('周一至周五 9:00-18:00 PHT', 'Monday-Friday 9:00-18:00 PHT', '月曜日～金曜日 9:00-18:00 PHT', '월요일-금요일 9:00-18:00 PHT'),
        isComingSoon: true
      })
    ]
  },
  {
    code: 'VN',
    name: localized('越南', 'Vietnam', 'ベトナム', '베트남'),
    city: localized('胡志明市', 'Ho Chi Minh City', 'ホーチミン市', '호치민시'),
    coordinates: { lat: 10.8231, lng: 106.6297 },
    office: comingSoonText,
    description: localized(
      '越南服务节点规划中，当前可通过区域团队支持本地交付需求。',
      'Vietnam service coverage is being planned and currently supported through regional teams.',
      'ベトナム向けサービス拠点は計画中で、現在は地域チームが連携して支援します。',
      '베트남 서비스 거점은 계획 중이며 현재는 지역 팀이 연계해 지원합니다.'
    ),
    email: defaultEmail,
    businessHours: localized('周一至周五 9:00-18:00 ICT', 'Monday-Friday 9:00-18:00 ICT', '月曜日～金曜日 9:00-18:00 ICT', '월요일-금요일 9:00-18:00 ICT'),
    timezone: 'Asia/Ho_Chi_Minh',
    offices: [
      createOffice({
        id: 'vietnam',
        title: localized('胡志明市服务区域', 'Ho Chi Minh Service Coverage', 'ホーチミンサービスエリア', '호치민 서비스 권역'),
        city: localized('胡志明市', 'Ho Chi Minh', 'ホーチミン市', '호치민'),
        coordinates: { lat: 10.8231, lng: 106.6297 },
        addressLines: comingSoonAddress,
        businessHours: localized('周一至周五 9:00-18:00 ICT', 'Monday-Friday 9:00-18:00 ICT', '月曜日～金曜日 9:00-18:00 ICT', '월요일-금요일 9:00-18:00 ICT'),
        isComingSoon: true
      })
    ]
  }
];

export default serviceRegions;
